import React, { Component } from 'react';
import SiteScreen from '../location/site.js';


class EditSiteScreen extends Component {
	/*== Lifecycle React js ==*/
	constructor(props) {
		super(props);
		this.state = {
			assetList: null
		}
	}

	render() {
		return(
			<SiteScreen />
		)
	}

}

export default EditSiteScreen;


// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/job/edit_site.js